import { render } from "./AppTitle.vue?vue&type=template&id=4827001f&scoped=true"
import script from "./AppTitle.vue?vue&type=script&lang=js"
export * from "./AppTitle.vue?vue&type=script&lang=js"

import "./AppTitle.vue?vue&type=style&index=0&id=4827001f&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4827001f"]])

export default __exports__